<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/xingzheng/dashboard" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/favicon.png" alt="Logo" height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/favicon.png" alt="Logo" height="20" />
            </span>
          </router-link>

          <route-link to="/xingzheng/dashboard" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/favicon.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/favicon.png" alt height="20" />
            </span>
          </route-link>
        </div>

        <button type="button" class="btn btn-sm px-3 font-size-24 d-lg-none header-item" data-toggle="collapse"
          @click="toggleMenu">
          <i class="ri-menu-2-line align-middle"></i>
        </button>

        <!-- App Search-->
        <form class="app-search d-none d-lg-block">
          <div class="position-relative">
            <input type="text" class="form-control" :placeholder="$t('navbar.search.text')" />
            <span class="ri-search-line"></span>
          </div>
        </form>

      </div>

      <div class="d-flex">
        <div class="dropdown d-inline-block ml-2">
          <button type="button" class="btn header-item noti-icon waves-effect" id="page-header-search-dropdown"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="ri-search-line"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
            aria-labelledby="page-header-search-dropdown">
            <form class="p-3">
              <div class="form-group m-0">
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="Search ..." />
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="submit">
                      <i class="ri-search-line"></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="">
          <button type="button" class="btn header-item noti-icon waves-effect">

            <b-button class="mx-1 text-white" variant="success" size="sm" v-b-modal.translate-modal>
              Local Ln
            </b-button>
            <translate-modal></translate-modal>
          </button>
        </div>

        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button type="button" class="btn header-item noti-icon waves-effect" data-toggle="fullscreen"
            @click="initFullScreen">
            <i class="ri-fullscreen-line"></i>
          </button>
        </div>

        <b-dropdown right variant="black" toggle-class="header-item" class="d-inline-block user-dropdown">
          <template v-slot:button-content>
            <img :src="`${transactionData.url}`" class="rounded-circle header-profile-user" alt="" />
            <!-- <img class="rounded-circle header-profile-user" 
            src="@/assets/images/users/avatar-2.jpg"
              alt="Header Avatar" /> -->
            <span class="d-none d-xl-inline-block ml-1">{{ user.username }}</span>
          </template>
          <!-- item-->
          <router-link to="/xingzheng/dashboard" custom v-slot="{ navigate }">
            <button @click="navigate" role="link" class="btn btn-sm btn-primary btn-edit d-flex dropdown-item">
              <i class="ri-user-line align-middle mr-1"></i>
              {{ $t('navbar.dropdown.kevin.list.profile') }}
            </button>
          </router-link>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="/logout">
            <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
            {{ $t("navbar.dropdown.kevin.list.logout") }}
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
// import simplebar from "simplebar-vue";
import userApi from "@/api/userApi"; // 👈 use your updated user API module
import i18n from "../i18n";
import { layoutComputed } from "@/state/helpers";
import TranslateModal from "@/components/translate";

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...layoutComputed,
  },
  components: {
    TranslateModal
    // simplebar
  },
  data() {
    return {
      transactionData: [],
      user: [],
    };
  },
  methods: {
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    setLanguage(locale) {
      i18n.locale = locale;
      this.current_language = i18n.locale;
    },
    getAfricanaData() {
      const self = this;
      userApi.getCurrentUser()
        .then(response => {
          self.transactionData = response.data;
          self.user = response.data;
        })
        .catch(error => {
          console.error("Error fetching user data:", error.message);
        });
    }
  },
  mounted() {
    this.getAfricanaData();
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            case "colored":
              document.body.setAttribute("data-topbar", "colored");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  },
};
</script>
